import type { IntlDateTimeFormats, IntlNumberFormats } from 'vue-i18n'

const dateFormats = {
    short: { year: 'numeric', month: '2-digit', day: '2-digit' },
    long: { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' },
    month: { year: 'numeric', month: 'long' },
    time: { hour: '2-digit', minute: '2-digit' },
} as const

const numFormats = {
    decimal: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 },
    integer: { style: 'decimal', maximumFractionDigits: 0 },
    currency: { style: 'currency', currency: 'EUR' },
    percent: { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 1 },
} as const

export const datetimeFormats: IntlDateTimeFormats = { hr: dateFormats, sl: dateFormats, en: dateFormats }
export const numberFormats: IntlNumberFormats = { hr: numFormats, sl: numFormats, en: numFormats }
